















































import { Vue, Component, Prop, Watch, } from "@/shared/vuepack";
import { EmployerThemeRequest } from "@/admin/types";
import VueRouter from "vue-router";
import { Validator } from "vee-validate";
import { UserPermission } from "@/shared/types";
import { useThemeStore } from "@/shared/store/theme";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component({})
export default class EmployerTheme extends Vue {
  $router: VueRouter;
  $validator: Validator;

  themeStore = useThemeStore();
  featureFlagStore = useFeatureFlagStore();
  rolePermissionsStore = useRolePermissionsStore();

  @Prop()
  employerId: string;

  selectedTheme = 0;
  submitDisabled = false;

  get hasEditPermission (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions
        ? this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalEmployerEdit)
        : true;
  }

  get isLoaded (): boolean {
    return this.themeStore.activeThemesIsLoaded;
    }
    created () {
      this.themeStore.getEmployerTheme(this.employerId as any);
      this.themeStore.getActiveThemes();
    }
    mounted () {
      this.selectedTheme = this.themeStore.employerTheme.themeId;
    }

  @Watch("themeStore.employerTheme.themeId", { deep: true })
    onStoreValueChange (newValue) {
      this.selectedTheme = newValue;
    }
    saveTheme () {
      this.$validator.validateAll().then(isValid => {
      if (!isValid || this.submitDisabled) {
        return;
      }
      if (this.themeStore.employerTheme.themeId === this.selectedTheme) {
        return;
      }
      this.submitDisabled = true;

      const empThemeRequest: EmployerThemeRequest = {
        employerId: Number(this.employerId),
        themeId: this.selectedTheme,
        delete: false
        };
      this.themeStore.saveEmployerTheme (empThemeRequest)
        .finally(() => this.submitDisabled = false);
      });
    }
    get showDeleteButton (): boolean {
      return this.themeStore.employerTheme.employerThemeId && this.themeStore.employerTheme.employerThemeId !== 0;
    }
    deleteTheme () {
      const empThemeRequest: EmployerThemeRequest = {
        employerId: Number(this.employerId),
        themeId: this.selectedTheme,
        delete: true
        };
      this.themeStore.saveEmployerTheme (empThemeRequest);
    }
    get primaryColor () {
      return this.themeStore.activeThemes.find(e => e.themeId === this.selectedTheme).primaryColor;
    }
    get secondaryColor () {
      return this.themeStore.activeThemes.find(e => e.themeId === this.selectedTheme).secondaryColor;
    }
    get tertiaryColor () {
      return this.themeStore.activeThemes.find(e => e.themeId === this.selectedTheme).tertiaryColor;
    }
    get buttonColor () {
      return this.themeStore.activeThemes.find(e => e.themeId === this.selectedTheme).isButtonColorPrimary
      ? this.primaryColor : this.secondaryColor;
    }
   get navButtonColor () {
     return this.themeStore.activeThemes.find(e => e.themeId === this.selectedTheme).isNavButtonColorSecondary
        ? this.secondaryColor : this.tertiaryColor;
   }
    get showColors () {
      return this.selectedTheme > 0;
    }
    @Watch("employerId")
    fetchEmployerTheme () {
      this.submitDisabled = false;
      this.themeStore.getEmployerTheme(this.employerId as any);
    }
  }
